import React from 'react';
import { useFormContext } from 'react-hook-form';
export const withFormProps = (Component) => (props) => {
    const { register } = useFormContext();
    const { onChange, onBlur, ref } = register(props.name);
    return React.createElement(Component, { onBlur: onBlur, onChange: onChange, ...props, ref: ref });
};
//# sourceMappingURL=withFormProps.js.map